import React from "react";
import { cn } from "./utils";

const TONE_CLASS = {
  primary: "border-slate-900 bg-slate-900 text-white hover:bg-slate-800",
  secondary: "border-slate-300 bg-white text-slate-800 hover:bg-slate-50",
  subtle: "border-slate-200 bg-slate-100 text-slate-800 hover:bg-slate-200",
  success: "border-emerald-700 bg-emerald-700 text-white hover:bg-emerald-600",
  danger: "border-rose-700 bg-rose-700 text-white hover:bg-rose-600",
};

const SIZE_CLASS = {
  sm: "h-8 px-3 text-xs",
  md: "h-9 px-3 text-sm",
  lg: "h-10 px-4 text-sm",
};

export default function Button({
  as: Component = "button",
  tone = "secondary",
  size = "md",
  className = "",
  children,
  type = "button",
  ...props
}) {
  return (
    <Component
      type={Component === "button" ? type : undefined}
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-sm border font-medium transition disabled:cursor-not-allowed disabled:opacity-60",
        TONE_CLASS[tone] || TONE_CLASS.secondary,
        SIZE_CLASS[size] || SIZE_CLASS.md,
        className
      )}
      {...props}
    >
      {children}
    </Component>
  );
}
